let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("16wRp")).then(() => parcelRequire('eT9yw'));